import { render, staticRenderFns } from "./Conceptos.vue?vue&type=template&id=80cb4248&"
import script from "./Conceptos.vue?vue&type=script&lang=js&"
export * from "./Conceptos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../Users/lucianocolucci/Desktop/Share Windows/IngeniAR/WebProject/Syscore-mods/Frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports